<template>
  <Sheet>
    <div class="mt-5 w-full shrink-0 px-5 pt-[5.5px] pb-[3.5px] text-gray-800">
      <div class="flex items-start">
        <div class="mr-4 size-9 shrink-0">
          <Thumbnail type="folder" />
        </div>
        <div v-truncate class="w-full">
          <div
            class="mb-1 font-medium text-[17px] leading-[20px]"
            data-truncate-target
          >
            {{ folder.name }}
          </div>
          <div class="font-secondary text-[14px] leading-[18px] text-gray-500">
            {{ subtitle }}
          </div>
        </div>
      </div>
    </div>

    <Sheet.Body class="px-0!">
      <Sheet.MenuSeparator />

      <Sheet.MenuItem :icon="TrashIcon" @click="handleDelete">
        Delete
      </Sheet.MenuItem>
      <Sheet.MenuItem :icon="PencilIcon" @click="handleRename">
        Rename
      </Sheet.MenuItem>
      <Sheet.MenuItem :icon="MoveIcon" @click="handleMove">
        Move
      </Sheet.MenuItem>

      <Sheet.MenuSeparator />

      <Sheet.MenuItem :icon="InfoIcon" @click="handleFolderInfo">
        Folder info
      </Sheet.MenuItem>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Sheet, Thumbnail, useSheet } from '@dacr/library'
import { TrashIcon, PencilIcon, MoveIcon, InfoIcon } from '@dacr/icons'
import { openModal, Modals } from '@/shared/dialogs/modals'
import { openDialog, Dialog } from '@/shared/dialogs/dialog'
import { openSheet, Sheets } from '@/shared/dialogs/sheets'
import type { Folder } from '@/shared/graphql/router/graphql'
import pluralize from 'pluralize'

const { close } = useSheet()

const props = defineProps<{
  folder: Folder
}>()

const folder = props.folder

const subtitle = computed(
  () => `${folder.totalFiles} ${pluralize('registration', folder.totalFiles)}`
)

const handleDelete = () => {
  close()
  openModal(Modals.DeleteFolders, { props: { items: [folder] } })
}

const handleRename = () =>
  openDialog(Dialog.RenameFolder, { props: { item: folder } })

const handleMove = () =>
  openDialog(Dialog.MoveItems, { props: { ids: [folder.id] } })

const handleFolderInfo = () =>
  openSheet(Sheets.FolderInfo, { props: { folder } })
</script>
